import { httpServices } from 'src/system/HttpServices/HttpService';
export default {
    getAllChats: function (data, signal) {
        return httpServices.get({
            path: '/dialogs',
            withCredentials: true,
            requestType: 'application',
            signal: signal,
            data: data,
        });
    },
    getUserChats: function (data, signal) {
        return httpServices.get({
            path: '/dialogs',
            withCredentials: true,
            requestType: 'application',
            signal: signal,
            data: data,
        });
    },
    getChatInfo: function (data, signal) {
        return httpServices.get({
            path: "/dialogs/".concat(data.id),
            withCredentials: true,
            requestType: 'application',
            signal: signal,
        });
    },
    getPersonalChatInfo: function (data, signal) {
        return httpServices.get({
            path: "/dialogs/personal/".concat(data.id),
            withCredentials: true,
            requestType: 'community',
            signal: signal,
        });
    },
    getMessages: function (id, data, signal) {
        return httpServices.get({
            path: "/dialogs/".concat(id, "/messages"),
            withCredentials: true,
            requestType: 'application',
            data: data,
            signal: signal,
        });
    },
    sendMessage: function (id, data) {
        return httpServices.post({
            path: "/dialogs/".concat(id, "/messages/send"),
            withCredentials: true,
            requestType: 'application',
            data: data,
        });
    },
    markChatAsRead: function (id) {
        return httpServices.post({
            path: "/dialogs/".concat(id, "/messages/view"),
            withCredentials: true,
            requestType: 'application',
            data: undefined,
        });
    },
    startChatWithAmbassador: function (data) {
        return httpServices.post({
            path: '/dialogs/create/ambassador',
            withCredentials: true,
            requestType: 'community',
            data: data,
        });
    },
    startChatWithAUser: function (data) {
        return httpServices.post({
            path: '/dialogs/create',
            withCredentials: true,
            requestType: 'application',
            data: data,
        });
    },
    startChatWithProspect: function (data) {
        return httpServices.post({
            path: '/dialogs/create/prospect',
            withCredentials: true,
            requestType: 'community',
            data: data,
        });
    },
    leaveChat: function (id) {
        return httpServices.put({
            path: "/dialogs/".concat(id, "/exit"),
            withCredentials: true,
            requestType: 'application',
            data: {},
        });
    },
    leaveFeedback: function (id, data) {
        return httpServices.post({
            path: "/dialogs/".concat(id, "/feedback"),
            withCredentials: true,
            requestType: 'application',
            data: {
                prospect_id: data.prospectId,
                comments: data.comments,
                score: data.score,
                dialogId: id,
            },
        });
    },
    reportChat: function (id, data) {
        return httpServices.put({
            path: "/dialogs/".concat(id, "/report"),
            withCredentials: true,
            requestType: 'application',
            data: {
                reported_reason: data.comment,
            },
        });
    },
    blockUser: function (userId, data) {
        return httpServices.post({
            path: '/users/prospects/block-toggle',
            requestType: 'common',
            useV2: true,
            data: {
                userId: userId,
                blockingReason: data.comment,
                isBlocked: data.isBlocked,
            },
        });
    },
    reportMessage: function (data) {
        return httpServices.post({
            path: '/dialogs/reportMessage',
            withCredentials: true,
            requestType: 'application',
            data: data,
        });
    },
};
